import axios from "axios";
import Links from "../constants/Links";

const Curriculum = {
    create: async (data) => {
        return axios.post(Links.curricula.create, data);
    },

    copy: async (sourceCurriculumId, data) => {
        return axios.post(Links.curricula.copy + sourceCurriculumId, data);
    },

    update: async (id, data) => {
        return axios.put(Links.curricula.update + id, data);
    },

    getById: async (id) => {
        return axios.get(Links.curricula.getById + id);
    },

    byProgramme: async (programmeId, programmeTypeId) => {
        const params = programmeTypeId ? { programme_type: programmeTypeId } : {};
        return axios.get(Links.curricula.byProgramme + programmeId, { params });
    },

    setDefault: async (id) => {
        return axios.post(Links.curricula.setDefault + id + "/set-default");
    },

    disable: async (id) => {
        return axios.delete(Links.curricula.disable + id);
    },

    createMapping: async (data) => {
        return axios.post(Links.curricula.mappings.create, data);
    },

    updateMapping: async (mappingId, data) => {
        return axios.put(Links.curricula.mappings.update + mappingId, data);
    },

    getMappingsByProgramme: async (programmeId) => {
        return axios.get(Links.curricula.mappings.byProgramme + programmeId);
    },

    activateMapping: async (mappingId) => {
        return axios.post(Links.curricula.mappings.activate + mappingId + "/activate");
    },

    deactivateMapping: async (mappingId) => {
        return axios.post(Links.curricula.mappings.deactivate + mappingId + "/deactivate");
    },

    deleteMapping: async (mappingId) => {
        return axios.delete(Links.curricula.mappings.delete + mappingId);
    },

    createOverride: async (data) => {
        return axios.post(Links.curricula.overrides.create, data);
    },

    removeOverride: async (studentId) => {
        return axios.delete(Links.curricula.overrides.remove + studentId);
    },

    createSemesterOverride: async (data) => {
        return axios.post(Links.curricula.overrides.semesterOverrides.create, data);
    },

    removeSemesterOverride: async (studentId, semesterId) => {
        return axios.delete(Links.curricula.overrides.semesterOverrides.delete + studentId + "/" + semesterId);
    },

    getSemesterOverrides: async (studentId) => {
        return axios.get(Links.curricula.overrides.semesterOverrides.forStudent + studentId);
    },

    resolve: async (studentId) => {
        return axios.get(Links.curricula.resolve + studentId);
    },

    getCourses: async (curriculumId) => {
        return axios.get(Links.curricula.courses.list + curriculumId + "/courses");
    },

    addCourse: async (curriculumId, data) => {
        return axios.post(Links.curricula.courses.add + curriculumId + "/courses", data);
    },

    bulkAddCourses: async (curriculumId, data) => {
        return axios.post(Links.curricula.courses.bulkAdd + curriculumId + "/courses/bulk", data);
    },

    updateCourse: async (curriculumId, programmeCourseId, data) => {
        return axios.put(Links.curricula.courses.update + curriculumId + "/courses/" + programmeCourseId, data);
    },

    removeCourse: async (curriculumId, programmeCourseId) => {
        return axios.delete(Links.curricula.courses.remove + curriculumId + "/courses/" + programmeCourseId);
    },

    assignCourse: async (curriculumId, programmeCourseId) => {
        return axios.post(Links.curricula.courses.assign + curriculumId + "/courses/" + programmeCourseId + "/assign");
    },

    prepareCourseMerge: async (curriculumId, data) => {
        return axios.post(
            Links.curricula.courses.mergePrepare + curriculumId + "/courses/merge/prepare",
            data
        );
    },

    executeCourseMerge: async (mergeId) => {
        return axios.post(Links.curricula.courseMerges.execute + mergeId + "/execute");
    },

    getStudentCourses: async (studentId) => {
        return axios.get(Links.curricula.students.courses + studentId + "/courses");
    },

    migrate: async (data) => {
        return axios.post(Links.curricula.migrate.bulk, data);
    },

    migrateOverrides: async (data) => {
        return axios.post(Links.curricula.migrate.overrides, data);
    },

    migrateStudent: async (data) => {
        return axios.post(Links.curricula.migrate.student, data);
    },

    listMigrations: async (params) => {
        return axios.get(Links.curricula.migrations.list, { params });
    },

    prepareMigration: async (data) => {
        return axios.post(Links.curricula.migrations.prepare, data);
    },

    prepareOverrideMigration: async (data) => {
        return axios.post(Links.curricula.migrations.prepareOverrides, data);
    },

    prepareStudentMigration: async (data) => {
        return axios.post(Links.curricula.migrations.prepareStudent, data);
    },

    getMigration: async (migrationId) => {
        return axios.get(Links.curricula.migrations.base + migrationId);
    },

    refreshMigration: async (migrationId) => {
        return axios.post(
            Links.curricula.migrations.base
                + migrationId
                + Links.curricula.migrations.refresh
        );
    },

    deleteMigration: async (migrationId) => {
        return axios.delete(Links.curricula.migrations.base + migrationId);
    },

    updateMigrationMapping: async (migrationId, sourceProgrammeCourseId, data) => {
        return axios.put(
            Links.curricula.migrations.base
                + migrationId
                + Links.curricula.migrations.mappings
                + sourceProgrammeCourseId,
            data
        );
    },

    getMigrationMappingRegistrations: async (migrationId, sourceProgrammeCourseId, params) => {
        return axios.get(
            Links.curricula.migrations.base
                + migrationId
                + Links.curricula.migrations.mappings
                + sourceProgrammeCourseId
                + Links.curricula.migrations.mappingRegistrations,
            { params }
        );
    },

    deleteMigrationMappingRegistration: async (migrationId, sourceProgrammeCourseId, registrationId) => {
        return axios.delete(
            Links.curricula.migrations.base
                + migrationId
                + Links.curricula.migrations.mappings
                + sourceProgrammeCourseId
                + Links.curricula.migrations.mappingRegistrations
                + "/"
                + registrationId
        );
    },

    executeMigration: async (migrationId) => {
        return axios.post(Links.curricula.migrations.base + migrationId + "/execute");
    },

    cleanupMigration: async (migrationId) => {
        return axios.post(Links.curricula.migrations.base + migrationId + "/cleanup");
    },
};

export default Curriculum;
